module.exports = __webpack_public_path__ + "img/lawnstarter.eb1d2c3a.svg";